// extracted by mini-css-extract-plugin
export default {"main__block__ticket__style":"СonfirmationParticipation_main__block__ticket__style__wpfo2"};